export default {
  __name: 'index',
  props: {
  visible: {
    type: String,
    required: false,
    default: null,
  },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

}